import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import MySpinner from './MySpinner';
import './TCFExamEntry.css'

const ExamEntrySection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [canSubmit, setCanSubmit] = useState(false);
  const [remainingSubmissions, setRemainingSubmissions] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Vérifier le nombre d'exercices restants seulement si l'utilisateur est connecté
    if (user) {
      checkRemainingExercises();
    }
  }, [user]);

  const checkRemainingExercises = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      const response = await fetch(`https://fwabl598k2.execute-api.us-west-1.amazonaws.com/dev/remainingtopics/speaking-corrections/can-submit/${user.uid}`, requestOptions);

      if (!response.ok) {
        throw new Error('Échec de la récupération des données');
      }

      const result = await response.json();

      setCanSubmit(result.canSubmit);
      setRemainingSubmissions(result.remaining || 0);
      setIsLoading(false);
    } catch (error) {
      setError('Une erreur est survenue lors de la vérification de votre compte');
      setIsLoading(false);
      console.error('Error checking eligibility:', error);
    }
  };

  const handleStartExam = () => {
    navigate('/writing-test');
  };

  const handleLoginRedirect = () => {
    navigate('/connexion', { state: { returnUrl: '/sujets-expression-ecrite' } });
  };

  return (
    <div className="tcf-exam-entry-section">
      <div className="tcf-exam-entry-container">
        <div className="tcf-exam-entry-card">
          <div className="tcf-exam-entry-header">
            <div className="tcf-exam-entry-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <h3 className="tcf-exam-entry-title">Examen d'Expression Écrite au TCF CANADA</h3>
          </div>

          <div className="tcf-exam-entry-content">
            <p className="tcf-exam-entry-description">
              Pratiquez et améliorez vos compétences en expression écrite avec nos examens en ligne, corrigés par une IA experte.
            </p>

            {isLoading ? (
              <div className="tcf-exam-entry-loading">
                <MySpinner loading={true} message="Vérification de votre compte..." />
              </div>
            ) : error ? (
              <div className="tcf-exam-entry-error">
                <p>{error}</p>
                <button onClick={checkRemainingExercises} className="tcf-exam-entry-retry-btn">
                  Réessayer
                </button>
              </div>
            ) : user ? (
              <div className="tcf-exam-entry-user-info">
                <div className="tcf-exam-entry-remaining">
                  <div className="tcf-exam-entry-remaining-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </div>
                  <p className="tcf-exam-entry-remaining-text">
                    <span>Examens restants : </span>
                    <strong>{remainingSubmissions}</strong>
                  </p>
                </div>

                <button
                  onClick={handleStartExam}
                  className="tcf-exam-entry-start-btn"
                  disabled={!canSubmit}
                >
                  {canSubmit ? "Commencer l'examen" : "Abonnement requis"}
                </button>

                {!canSubmit && (
                  <div className="tcf-exam-entry-subscription-note">
                    <p>Vous avez épuisé votre quota d'examens. Veuillez souscrire à l'un de nos forfaits pour continuer.</p>
                    <a href="/offres" className="tcf-exam-entry-subscription-link">
                      Voir nos offres
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <div className="tcf-exam-entry-guest">
                <p className="tcf-exam-entry-guest-message">
                  Connectez-vous pour accéder à nos examens d'Expression Écrite
                </p>
                <button onClick={handleLoginRedirect} className="tcf-exam-entry-login-btn">
                  Se connecter
                </button>
                <p className="tcf-exam-entry-register-note">
                  Pas encore de compte ?
                  <a href="/inscription" className="tcf-exam-entry-register-link">
                    S'inscrire gratuitement
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


export default ExamEntrySection;